export default "__VITE_ASSET__D4pY3bYy__"